// extracted by mini-css-extract-plugin
export default {"ellipsis":"RTrmsaXIRZ4UYMNG8bTt__ellipsis___"};